import React from "react";

import axios from "axios";

import Select from "react-select";

import { RiCloseFill } from "react-icons/ri";

import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import { getHost, giataOperators, stars } from "../utils";
import { useDispatch } from "react-redux";
import {
  addLoading,
  decLoading,
  setIsloadertext,
} from "amadeusredux/lib/systemSlice";

function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
}
  
  

export default function ImagesPopup(props) {
    const { offer, hotel, setPopupOpen } = props;
  
    const dispatch = useDispatch();
  
    //const [galleryUrls, setGalleryUrls] = React.useState([]);
    const [allImages, setAllImages] = React.useState([]);
    const [bigImages, setBigImages] = React.useState([]);
    const [bigUrl, setBigUrl] = React.useState(null);
    const [bigIdx, setBigIdx] = React.useState(-1);
    const [overpict, setOverpict] = React.useState(-1);
    const [clickIdx, setClickIdx] = React.useState(-1);
  
    const [tab, setTab] = React.useState("operator");
  
    const [driveImages, setDriveImages] = React.useState([]);
  
    const [filter, setFilter] = React.useState({
      vc: null,
      typ: null,
      cid: null,
    });
    const [imgCount, setImgCount] = React.useState(30);
  
    const popupRef = React.useRef(null);
  
    const galleryRef = React.useRef(null);
    const pictureRef = React.useRef(null);
  
    const picturesRef = React.useRef(null);
    const [picid, setPicid] = React.useState(null);
  
    React.useEffect(() => {
      
      dispatch(addLoading());
      dispatch(setIsloadertext(false));
      fetch(
        "https://www.giatadrive.com/" +
          encodeURIComponent(hotel?.HotelCodes?.HotelGiataID) +
          "/json"
      )
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (Array.isArray(data.images)) {
            setDriveImages(
              data.images.filter(
                (e) =>
                  e?.sizes &&
                  e.sizes["320"] &&
                  e.sizes["320"].href &&
                  e.sizes["1080"] &&
                  e.sizes["1080"].href
              )
            );
          }
        })
        .finally(() => {
          dispatch(decLoading());
          dispatch(setIsloadertext(true));
        });
    }, []);
  
    React.useEffect(() => {
     
      dispatch(addLoading());
      dispatch(setIsloadertext(false));
  
      axios
        .get(
          getHost() +
            "/giatagallery/" +
            encodeURIComponent(hotel?.HotelCodes?.HotelGiataID)
        )
        .then((response) => {
          //console.log(response.data.result.data);
  
          //let urls = [];
          let images = [];
          let bImages = [];
  
          if (
            Array.isArray(response?.data?.result?.data) &&
            response?.data?.result?.data.length > 0
          ) {
            for (let i = 0; i < response.data.result.data.length; i++) {
              let vc = response.data.result.data[i].Veranstaltercode[0];
              let vn = response.data.result.data[i].Veranstaltername[0];
              let cid = response.data.result.data[i].KatalogID[0];
              let cn = response.data.result.data[i].Katalogname[0];
              let vlogo =
                Array.isArray(response.data.result.data[i].provider_logo_url) &&
                response.data.result.data[i].provider_logo_url.length > 0
                  ? response.data.result.data[i].provider_logo_url[0]._
                  : null;
              let clogo =
                Array.isArray(response.data.result.data[i].catalog_cover_url) &&
                response.data.result.data[i].catalog_cover_url.length > 0
                  ? response.data.result.data[i].catalog_cover_url[0]._
                  : null;
  
              if (Array.isArray(response.data.result.data[i].Bildfile)) {
                /*urls = [
                  ...urls,
                  ...response.data.result.data[i].Bildfile.map((e) => e["_"]),
                ];*/
  
                let imgs = response.data.result.data[i].Bildfile.filter(
                  (e) => e.$.size === "320"
                ).map((e) => {
                  return {
                    url: e["_"],
                    ...e["$"],
                    vc: vc,
                    vn: vn,
                    cn: cn,
                    cid: cid,
                    clogo: clogo,
                    vlogo: vlogo,
                  };
                });
  
                for (let i = 0; i < imgs.length; i++) {
                  if (!images.map((e) => e.id).includes(imgs[i].id))
                    images.push(imgs[i]);
                }
  
                let bimgs = response.data.result.data[i].Bildfile.filter(
                  (e) => e.$.size !== "320"
                ).map((e) => {
                  return {
                    url: e["_"],
                    ...e["$"],
                    vc: vc,
                    vn: vn,
                    cn: cn,
                    cid: cid,
                    clogo: clogo,
                    vlogo: vlogo,
                  };
                });
  
                for (let i = 0; i < bimgs.length; i++) {
                  if (!bImages.map((e) => e.id).includes(bimgs[i].id))
                    bImages.push(bimgs[i]);
                }
              }
            }
          }
  
          images = images.filter((e) =>
            bImages.find(
              (b) => e.cid === b.cid && e.vc === b.vc && e.seq === b.seq
            )
          );
          //console.log(images);
          //urls = urls.filter(onlyUnique);
          //if (urls.length > 102) urls = urls.slice(0, 100);
          //setGalleryUrls(urls);
          setAllImages(images);
          setBigImages(bImages);
        })
        .finally(() => {
          dispatch(decLoading());
          dispatch(setIsloadertext(true));
        });
    }, []);
    //console.log(allImages.length);
    //console.log(bigImages.length);
  
    let bt = [];
  
    if (filter.vc) {
      for (let i = 0; i < bildtyps.length; i++) {
        //console.log(allImages);
        let ct = allImages
          .filter((element) => element.vc === filter.vc)
          .filter((element) => (!filter.cid ? true : element.cid === filter.cid))
          .filter((element) => element.typ === bildtyps[i].id).length;
        //console.log(ct);
        if (ct > 0) {
          bt.push({ ...bildtyps[i], count: ct });
        }
      }
    }
  
    let cats = [];
    if (filter.vc) {
      let cts = allImages.filter((element) => element.vc === filter.vc);
      for (let i = 0; i < cts.length; i++) {
        //console.log(allImages);
  
        if (!cats.map((e) => e.cid).includes(cts[i].cid)) {
          cats.push({
            value: cts[i].cid,
            label: cts[i].cn,
            cid: cts[i].cid,
            clogo: allImages[i].clogo,
            count: allImages
              .filter((element) => element.vc === filter.vc)
              .filter((element) => element.cid === cts[i].cid).length,
          });
        }
      }
    }
  
    if (cats.length === 1 && !filter.cid) {
      setFilter({ ...filter, cid: cats[0].cid });
    }
  
    let vcs = [];
    for (let i = 0; i < allImages.length; i++) {
      if (!vcs.map((e) => e.vc).includes(allImages[i].vc)) {
        let go = giataOperators.find((e) => e.vc === allImages[i].vc);
  
        vcs.push({
          value: allImages[i].vc,
          label: allImages[i].vn,
          vc: allImages[i].vc,
          vn: go ? go.vn : allImages[i].vn,
          vlogo: allImages[i].vlogo,
        });
      }
    }
  
    //console.log(vcs);
  
    for (let i = 0; i < vcs.length; i++) {
      //console.log(allImages);
      let ct = allImages.filter((element) => element.vc === vcs[i].vc).length;
      //console.log(ct);
      vcs[i].count = ct;
    }
  
    vcs.sort((a, b) => {
      return a.vn.toLowerCase().localeCompare(b.vn.toLowerCase());
    });
  
    if (vcs.length > 0 && !filter.vc) {
      setFilter({ vc: vcs[0].vc, typ: null, cid: null });
    }
  
    bt.sort((a, b) => {
      return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
    });
  
    cats.sort((a, b) => {
      return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
    });
  
    let bigGallery = bigImages
      .filter((element) => (!filter.typ ? true : element.typ === filter.typ))
      .filter((element) => (!filter.cid ? true : element.cid === filter.cid))
      .filter((element) => (!filter.vc ? true : element.vc === filter.vc));
  
    /*let bigUrl = null;
    if (bigImage) {
      let idx = -1;
      for (let i = 0; i < bigGallery.length; i++) {
        if (
          bigGallery[i].cid === bigImage.cid &&
          bigGallery[i].vc === bigImage.vc &&
          bigGallery[i].seq === bigImage.seq
        ) {
          idx = i;
          break;
        }
      }
      if (idx > -1) bigIdx = idx;
      if (
        bigImages.find(
          (e) =>
            e.cid === bigImage.cid &&
            e.vc === bigImage.vc &&
            e.seq === bigImage.seq
        )
      ) {
        bigUrl = bigImages.find(
          (e) =>
            e.cid === bigImage.cid &&
            e.vc === bigImage.vc &&
            e.seq === bigImage.seq
        ).url;
      }
    }*/
  
    let smallGallery = allImages
      .filter((element) => (!filter.typ ? true : element.typ === filter.typ))
      .filter((element) => (!filter.cid ? true : element.cid === filter.cid))
      .filter((element) => (!filter.vc ? true : element.vc === filter.vc));
  
    let width = 900;
  
    if (popupRef.current?.clientWidth) {
      width = popupRef.current?.clientWidth - 100;
    }
    if (galleryRef.current?.clientWidth) {
      width = galleryRef.current?.clientWidth;
    }
  
    let galPictCount = Math.floor(width / 180);
  
    let startIdx = bigIdx - Math.floor(galPictCount / 2);
    if (startIdx < 0) {
      startIdx = 0;
    }
  
    if (tab === "operator") {
      if (startIdx > smallGallery.length - galPictCount) {
        startIdx = bigGallery.length - galPictCount;
      }
  
      if (smallGallery.length < galPictCount + 1) {
        startIdx = 0;
      }
    }
  
    if (tab === "drive") {
      if (startIdx > driveImages.length - galPictCount) {
        startIdx = driveImages.length - galPictCount;
      }
  
      if (driveImages.length < galPictCount + 1) {
        startIdx = 0;
      }
    }
  
    return (
      <div
        ref={popupRef}
        className="hotelinfoframe"
        style={{ zIndex: 10001, opacity: 1 }}
      >
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "50%", paddingLeft: "16px" }}>
            <span className="hotelview3">
              {
                hotel.Name
              }
            </span>
            &nbsp;
            {offer &&
              offer.OfferServices &&
              stars(
                offer.OfferServices.Package.Accommodation.HotelOfferCategory * 1
              )}
          </div>
          <div className="hotelinfoclose">
            <RiCloseFill
              onClick={() => setPopupOpen(false)}
              style={{ fontSize: "1.5rem", margin: "auto" }}
            />
          </div>
        </div>
        {driveImages.length > 0 && (
          <div style={{ display: "flex" }}>
            <span style={{ flexGrow: 1 }}></span>
            <span
              style={{ width: 100, borderBottom: "1px solid #a0a0a0" }}
            ></span>
            <span
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                fontWeight: tab === "operator" ? 600 : undefined,
                fontSize: "120%",
                borderBottom:
                  tab === "operator" ? "2px solid #a0a0a0" : "1px solid #a0a0a0",
                cursor: tab === "operator" ? undefined : "pointer",
              }}
              onClick={() => {
                if (tab === "operator") return;
                setBigUrl(null);
                setBigIdx(-1);
                setTab("operator");
                setImgCount(30);
                if (picturesRef?.current) picturesRef.current.scrollTop = 0;
              }}
            >
              Veranstalterbilder
            </span>
            {driveImages.length > 0 && (
              <span
                style={{
                  paddingLeft: 20,
                  paddingRight: 20,
                  fontWeight: tab === "drive" ? 600 : undefined,
                  fontSize: "120%",
                  borderBottom:
                    tab === "drive" ? "2px solid #a0a0a0" : "1px solid #a0a0a0",
                  cursor: tab === "drive" ? undefined : "pointer",
                }}
                onClick={() => {
                  if (tab === "drive") return;
                  setBigUrl(null);
                  setBigIdx(-1);
                  setTab("drive");
                  setImgCount(30);
                  if (picturesRef?.current) picturesRef.current.scrollTop = 0;
                }}
              >
                Bilder des Hotelinhabers
              </span>
            )}{" "}
            <span
              style={{ minWidth: 100, borderBottom: "1px solid #a0a0a0" }}
            ></span>
            <span style={{ flexGrow: 1 }}></span>
          </div>
        )}
        {tab === "drive" && (
          <>
            {bigUrl && (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  overflowY: "scroll",
                }}
              >
                <div style={{ flexGrow: 1 }}></div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ flexGrow: 1 }}></div>
                  <div style={{ display: "flex" }}>
                    <div style={{ flexGrow: 1 }}></div>
                    {bigIdx > 0 && (
                      <FaChevronCircleLeft
                        onClick={() => {
                          setBigIdx(bigIdx - 1);
                          setBigUrl(driveImages[bigIdx - 1].sizes["1080"].href);
                        }}
                        size={40}
                        style={{ cursor: "pointer", color: "rgba(0,0,0,0.75)" }}
                      />
                    )}
                    {bigIdx < 1 && (
                      <FaChevronCircleLeft
                        size={40}
                        style={{ color: "rgba(210,210,210,0.75)" }}
                      />
                    )}
                    &nbsp;&nbsp;&nbsp;
                  </div>
                  <div style={{ flexGrow: 1 }}></div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span style={{ flexGrow: 1 }}>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setBigUrl(null);
                        //console.log(pictureRef);
                        window.setTimeout(() => {
                          pictureRef?.current?.scrollIntoView();
                          //picturesRef.current.scrollTop = 50;
                        }, 200);
                      }}
                    >
                      &lt; zurück zur Übersicht
                    </span>
                  </span>
                  <img
                    style={{
                      borderRadius: 10,
                      height: "90%",
                      objectFit: "cover",
                      cursor:
                        bigIdx < driveImages.length - 1 ? "pointer" : undefined,
                      width: "100%",
                    }}
                    onClick={() => {
                      if (bigIdx < driveImages.length - 1) {
                        setBigIdx(bigIdx + 1);
                        setBigUrl(driveImages[bigIdx + 1].sizes["1080"].href);
                      }
                      /*
                  setBigUrl(null);
                  //console.log(pictureRef);
                  window.setTimeout(() => {
                    pictureRef?.current?.scrollIntoView();
                    //picturesRef.current.scrollTop = 50;
                  }, 200);*/
                    }}
                    src={bigUrl}
                    alt=""
                  />
                  <div style={{ display: "flex" }}>
                    <span style={{ flexGrow: 1 }}></span>
                    <span>
                      {bigIdx + 1}/{driveImages.length}
                    </span>
                    <span style={{ flexGrow: 1 }}></span>
                  </div>
                </div>
  
                <div
                  style={{
                    display: "flex",
                    flexGrown: 1,
                    flexDirection: "column",
                  }}
                >
                  <div style={{ flexGrow: 1 }}></div>
                  <div>
                    &nbsp;&nbsp;&nbsp;
                    {bigIdx < driveImages.length - 1 && (
                      <FaChevronCircleRight
                        onClick={() => {
                          setBigIdx(bigIdx + 1);
                          setBigUrl(driveImages[bigIdx + 1].sizes["1080"].href);
                        }}
                        size={40}
                        style={{ cursor: "pointer", color: "rgba(0,0,0,0.75)" }}
                      />
                    )}
                    {bigIdx >= driveImages.length - 1 && (
                      <FaChevronCircleRight
                        size={40}
                        style={{ color: "rgba(210,210,210,0.75)" }}
                      />
                    )}
                  </div>
                  <div style={{ flexGrow: 1 }}></div>
                </div>
                <div style={{ flexGrow: 1 }}></div>
              </div>
            )}
            {bigUrl && (
              <div ref={galleryRef} style={{ flexGrow: 1, display: "flex" }}>
                <span style={{ flexGrow: 1 }}></span>
                <span>
                  {driveImages
                    .filter(
                      (e, idx) => idx >= startIdx && idx < startIdx + galPictCount
                    )
                    .map((e, idx) => {
                      return (
                        <img
                          onClick={() => {
                            setBigIdx(idx + startIdx);
                            setClickIdx(idx);
                            setBigUrl(
                              driveImages[idx + startIdx].sizes["1080"].href
                            );
                          }}
                          onMouseOver={() => {
                            setOverpict(idx + startIdx);
                            setClickIdx(-1);
                          }}
                          onMouseOut={() => {
                            setOverpict(-1);
                            setClickIdx(-1);
                          }}
                          style={{
                            filter:
                              idx + startIdx === bigIdx ||
                              idx === clickIdx ||
                              overpict === idx + startIdx
                                ? undefined
                                : "opacity(50%)",
                            height: 100,
                            width: 160,
                            objectFit: "cover",
                            borderRadius: 5,
                            marginRight: 16,
                          }}
                          src={e.sizes["320"].href}
                          alt=""
                        />
                      );
                    })}
                </span>
                <span style={{ flexGrow: 1 }}></span>
              </div>
            )}
            {!bigUrl && (
              <div
                ref={picturesRef}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  paddingTop: 20,
                  paddingBottom: 20,
                  overflowY: "scroll",
                }}
              >
                {driveImages
                  .filter((element, idx) => idx < imgCount)
                  .map((img, idx) => {
                    return (
                      <span
                        style={{
                          marginBottom: 10,
                          cursor: "pointer",
                          marginRight: 10,
                        }}
                        ref={img.id === picid ? pictureRef : undefined}
                        onClick={() => {
                          setPicid(img.id);
  
                          setBigIdx(idx);
                          setBigUrl(img.sizes["1080"].href);
                        }}
                      >
                        <img
                          src={img.sizes["320"].href}
                          alt=""
                          style={{
                            borderRadius: 5,
                            width: 320,
                            height: 200,
                            objectFit: "cover",
                          }}
                        />
                      </span>
                    );
                  })}
                {driveImages.length > imgCount && (
                  <div
                    style={{
                      cursor: "pointer",
                      width: 320,
                      height: 200,
                      borderRadius: 5,
                      padding: 10,
                      backgroundColor: "#a0a0a0",
                    }}
                    onClick={() => setImgCount(imgCount + 30)}
                  >
                    <div style={{ margin: "auto" }}>mehr...</div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
        {tab === "operator" && (
          <>
            {bigUrl && (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  overflowY: "scroll",
                }}
              >
                <div style={{ flexGrow: 1 }}></div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ flexGrow: 1 }}></div>
                  <div style={{ display: "flex" }}>
                    <div style={{ flexGrow: 1 }}></div>
                    {bigIdx > 0 && (
                      <FaChevronCircleLeft
                        onClick={() => {
                          setBigIdx(bigIdx - 1);
                          setBigUrl(bigGallery[bigIdx - 1].url);
                        }}
                        size={40}
                        style={{ cursor: "pointer", color: "rgba(0,0,0,0.75)" }}
                      />
                    )}
                    {bigIdx < 1 && (
                      <FaChevronCircleLeft
                        size={40}
                        style={{ color: "rgba(210,210,210,0.75)" }}
                      />
                    )}
                    &nbsp;&nbsp;&nbsp;
                  </div>
                  <div style={{ flexGrow: 1 }}></div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span style={{ flexGrow: 1 }}>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setBigUrl(null);
                        //console.log(pictureRef);
                        window.setTimeout(() => {
                          pictureRef?.current?.scrollIntoView();
                          //picturesRef.current.scrollTop = 50;
                        }, 200);
                      }}
                    >
                      &lt; zurück zur Übersicht
                    </span>
                  </span>
                  <img
                    style={{
                      borderRadius: 10,
                      height: "90%",
                      objectFit: "cover",
                      cursor:
                        bigIdx < bigGallery.length - 1 ? "pointer" : undefined,
                      width: "100%",
                    }}
                    onClick={() => {
                      if (bigIdx < bigGallery.length - 1) {
                        setBigIdx(bigIdx + 1);
                        setBigUrl(bigGallery[bigIdx + 1].url);
                      }
                      /*
                  setBigUrl(null);
                  //console.log(pictureRef);
                  window.setTimeout(() => {
                    pictureRef?.current?.scrollIntoView();
                    //picturesRef.current.scrollTop = 50;
                  }, 200);*/
                    }}
                    src={bigUrl}
                    alt=""
                  />
                  <div style={{ display: "flex" }}>
                    <span style={{ flexGrow: 1 }}></span>
                    <span>
                      {bigIdx + 1}/{bigGallery.length}
                    </span>
                    <span style={{ flexGrow: 1 }}></span>
                  </div>
                </div>
  
                <div
                  style={{
                    display: "flex",
                    flexGrown: 1,
                    flexDirection: "column",
                  }}
                >
                  <div style={{ flexGrow: 1 }}></div>
                  <div>
                    &nbsp;&nbsp;&nbsp;
                    {bigIdx < bigGallery.length - 1 && (
                      <FaChevronCircleRight
                        onClick={() => {
                          setBigIdx(bigIdx + 1);
                          setBigUrl(bigGallery[bigIdx + 1].url);
                        }}
                        size={40}
                        style={{ cursor: "pointer", color: "rgba(0,0,0,0.75)" }}
                      />
                    )}
                    {bigIdx >= bigGallery.length - 1 && (
                      <FaChevronCircleRight
                        size={40}
                        style={{ color: "rgba(210,210,210,0.75)" }}
                      />
                    )}
                  </div>
                  <div style={{ flexGrow: 1 }}></div>
                </div>
                <div style={{ flexGrow: 1 }}></div>
              </div>
            )}
  
            {bigUrl && (
              <div ref={galleryRef} style={{ flexGrow: 1, display: "flex" }}>
                <span style={{ flexGrow: 1 }}></span>
                <span>
                  {smallGallery
                    .filter(
                      (e, idx) => idx >= startIdx && idx < startIdx + galPictCount
                    )
                    .map((e, idx) => {
                      return (
                        <img
                          onClick={() => {
                            setBigIdx(idx + startIdx);
                            setClickIdx(idx);
                            setBigUrl(bigGallery[idx + startIdx].url);
                          }}
                          onMouseOver={() => {
                            setOverpict(idx + startIdx);
                            setClickIdx(-1);
                          }}
                          onMouseOut={() => {
                            setOverpict(-1);
                            setClickIdx(-1);
                          }}
                          style={{
                            filter:
                              idx + startIdx === bigIdx ||
                              idx === clickIdx ||
                              overpict === idx + startIdx
                                ? undefined
                                : "opacity(50%)",
                            height: 100,
                            width: 160,
                            objectFit: "cover",
                            borderRadius: 5,
                            marginRight: 16,
                          }}
                          src={e.url}
                          alt=""
                        />
                      );
                    })}
                </span>
                <span style={{ flexGrow: 1 }}></span>
              </div>
            )}
  
            {!bigUrl && <div>&nbsp;</div>}
  
            {!bigUrl && vcs.length > 0 && (
              <Select
                value={
                  filter.vc
                    ? vcs.find((e) => e.vc === filter.vc)
                    : { value: "", label: "" }
                }
                className="basic-single"
                classNamePrefix="select"
                name="vc"
                options={vcs}
                formatOptionLabel={(opt) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "left",
                      }}
                    >
                      <div>
                        <img src={opt.vlogo} alt="" />
                      </div>
                      <div>
                        &nbsp;&nbsp;{opt.vn} ({opt.count})
                      </div>
                    </div>
                  );
                }}
                onChange={(data) => {
                  setImgCount(30);
                  if (picturesRef?.current) picturesRef.current.scrollTop = 0;
                  setFilter({ vc: data.vc, typ: null, cid: null });
                }}
              />
            )}
  
            {1 == 0 && !bigUrl && cats.length > 1 && <div>&nbsp;</div>}
  
            {1 == 0 && !bigUrl && cats.length > 1 && (
              <Select
                value={
                  filter.cid
                    ? cats.find((e) => e.cid === filter.cid)
                    : { value: "", label: "kein Katalog ausgewählt" }
                }
                className="basic-single"
                classNamePrefix="select"
                name="cat"
                options={cats}
                isClearable={cats.length > 1}
                formatOptionLabel={(opt) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "left",
                      }}
                    >
                      {opt.clogo && (
                        <div>
                          <img src={opt.clogo} style={{ width: 20 }} alt="" />
                        </div>
                      )}
                      <div>
                        &nbsp;&nbsp;{opt.label} {opt.count && <>({opt.count})</>}
                      </div>
                    </div>
                  );
                }}
                onChange={(data) => {
                  setImgCount(30);
                  if (picturesRef?.current) picturesRef.current.scrollTop = 0;
                  if (data === null) {
                    setFilter({ vc: filter.vc, typ: null, cid: null });
                  } else {
                    setFilter({ vc: filter.vc, typ: null, cid: data.cid });
                  }
                }}
              />
            )}
  
            {!bigUrl && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                {filter.cid && (
                  <span
                    style={{
                      cursor: "pointer",
                      marginRight: 10,
                    }}
                    onClick={() => {
                      setImgCount(30);
                      if (picturesRef?.current) picturesRef.current.scrollTop = 0;
                      setFilter({ vc: filter.vc, typ: null, cid: filter.cid });
                    }}
                  >
                    Alle Bilder
                  </span>
                )}
                {bt.map((element) => (
                  <span
                    style={{
                      marginRight: 10,
                      color: filter.typ === element.id ? "#ff00ff" : undefined,
                      cursor: filter.typ === element.id ? undefined : "pointer",
                    }}
                    onClick={() => {
                      if (filter.typ === element.id) return;
                      setImgCount(30);
                      if (picturesRef?.current) picturesRef.current.scrollTop = 0;
                      setFilter({
                        vc: filter.vc,
                        typ: element.id,
                        cid: filter.cid,
                      });
                    }}
                  >
                    {element.label} ({element.count})
                  </span>
                ))}
              </div>
            )}
            {!bigUrl && (
              <div
                ref={picturesRef}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  paddingTop: 20,
                  paddingBottom: 20,
                  overflowY: "scroll",
                }}
              >
                {filter &&
                  allImages
                    .filter((element) =>
                      !filter.typ ? true : element.typ === filter.typ
                    )
                    .filter((element) =>
                      !filter.cid ? true : element.cid === filter.cid
                    )
                    .filter((element) =>
                      !filter.vc ? true : element.vc === filter.vc
                    )
  
                    .filter((element, idx) => idx < imgCount)
                    .map((img) => (
                      <span
                        style={{
                          marginBottom: 10,
                          cursor: "pointer",
                          marginRight: 10,
                        }}
                      >
                        <img
                          style={{
                            borderRadius: 5,
                            width: 320,
                            height: 200,
                            objectFit: "cover",
                          }}
                          ref={img.id === picid ? pictureRef : undefined}
                          onClick={() => {
                            setPicid(img.id);
  
                            let idx = -1;
                            for (let i = 0; i < bigGallery.length; i++) {
                              if (
                                bigGallery[i].cid === img.cid &&
                                bigGallery[i].vc === img.vc &&
                                bigGallery[i].seq === img.seq
                              ) {
                                idx = i;
                                break;
                              }
                            }
                            if (idx > -1) {
                              setBigIdx(idx);
                              setBigUrl(bigGallery[idx].url);
                            }
                          }}
                          src={img.url}
                          alt=""
                        />
                      </span>
                    ))}
  
                {/*!filter &&
            galleryUrls.map((img) => (
              <span style={{ marginBottom: 10, marginRight: 10 }}>
                <img src={img} alt="" />
              </span>
            ))*/}
                {allImages
                  .filter((element) =>
                    !filter.typ ? true : element.typ === filter.typ
                  )
                  .filter((element) =>
                    !filter.cid ? true : element.cid === filter.cid
                  )
                  .filter((element) =>
                    !filter.vc ? true : element.vc === filter.vc
                  ).length > imgCount && (
                  <div
                    style={{
                      cursor: "pointer",
                      width: 320,
                      height: 200,
                      borderRadius: 5,
                      padding: 10,
                      backgroundColor: "#a0a0a0",
                    }}
                    onClick={() => setImgCount(imgCount + 30)}
                  >
                    <div style={{ margin: "auto" }}>mehr...</div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    );
  }
  
  const bildtyps = [
    { id: "A", label: "Außenansicht" },
    { id: "AN", label: "Außenansicht" },
    { id: "AP", label: "Wohnbeispiel - Apartment" },
    { id: "AU", label: "Außen/Umgebung ohne Hotel" },
    { id: "BA", label: "Bar" },
    { id: "BD", label: "Badezimmer" },
    { id: "BG", label: "Wohnbeispiel - Bungalow" },
    { id: "CF", label: "Café" },
    { id: "EI", label: "Eingang" },
    { id: "EK", label: "Shopping/Einkaufen" },
    { id: "ET", label: "Etage/Flur" },
    { id: "F", label: "Sport und Freizeit" },
    { id: "FAD", label: "Adventure" },
    { id: "FO", label: "Folklore" },
    { id: "FR", label: "Fitness/Wellness" },
    { id: "FRE", label: "Relax" },
    { id: "FRR", label: "Frühstücksraum" },
    { id: "FZ", label: "Familienzimmer" },
    { id: "GA", label: "Gartenanlage" },
    { id: "HB", label: "Hallenbad" },
    { id: "IN", label: "Innenhof" },
    { id: "IT", label: "Internetcafé" },
    { id: "K", label: "Konferenzraum" },
    { id: "KL", label: "Kultur" },
    { id: "KO", label: "Konferenzraum" },
    { id: "KU", label: "Kunst" },
    { id: "L", label: "Lobby/Empfang" },
    { id: "LG", label: "Logo" },
    { id: "LK", label: "Landkarte/Karte" },
    { id: "LO", label: "Lobby" },
    { id: "LS", label: "Landschaft/Natur" },
    { id: "LU", label: "Luftaufnahme" },
    { id: "MF", label: "Mietfahrzeug" },
    { id: "MHS", label: "Meer / Hafen / Schiff" },
    { id: "MOD", label: "Modellaufnahme" },
    { id: "P", label: "Pool" },
    { id: "PB", label: "Poolbar" },
    { id: "PE", label: "Personen" },
    { id: "PEF", label: "Familie" },
    { id: "PEH", label: "Hochzeit" },
    { id: "PEK", label: "Kinder" },
    { id: "PEP", label: "Paar" },
    { id: "PER", label: "Romance" },
    { id: "PEY", label: "Party" },
    { id: "PO", label: "Poolanlage" },
    { id: "PR", label: "Preis" },
    { id: "R", label: "Restaurant" },
    { id: "RE", label: "Restaurant" },
    { id: "RK", label: "Zimmerküche" },
    { id: "RV", label: "Zimmerblick" },
    { id: "RZ", label: "Rezeption" },
    { id: "S", label: "Strand" },
    { id: "SB", label: "Strandbar" },
    { id: "SD", label: "Schiffsdeck" },
    { id: "SE", label: "Sehenswürdigkeiten" },
    { id: "SK", label: "Skigebiet" },
    { id: "SN", label: "Snackbar" },
    { id: "SP", label: "Sport" },
    { id: "SR", label: "Seminarraum" },
    { id: "ST", label: "Strand" },
    { id: "STA", label: "Stadt(ansicht)" },
    { id: "SU", label: "Wohnbeispiel/Suite" },
    { id: "SW", label: "Schwimmbad" },
    { id: "TE", label: "Terrasse" },
    { id: "TI", label: "Tier(e)" },
    { id: "TR", label: "Terrasse" },
    { id: "TS", label: "Unterhaltung" },
    { id: "UM", label: "Umgebung" },
    { id: "W", label: "Wohnbeispiel" },
    { id: "WBA", label: "Wasseraktivitäten" },
    { id: "WE", label: "Hotel Standardbild" },
    { id: "WEL", label: "Wellness" },
    { id: "X", label: "Sonstiges" },
    { id: "ZI", label: "Wohnbeispiel/Zimmer" },
  ];